import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../Actions/LoginAction';
// import { withTranslation } from 'react-i18next';
import { withTranslation } from 'react-i18next';
import * as LoginController from '../Controller/LoginController';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Utility from '../../../Utility/Utility'

class UpdatePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalShow: false,
            updatedPasswordSession: "",
            challangeName: "",
            userName: "",
            email: "",
            password: ""
        }
    }

    componentDidMount() {
        this.setParam();
    }

    //set email and password initially 
    setParam = () => {
        this.setState({
            email: this.props.match.params.email,
            password: this.props.match.params.password
        }, () => {
            this.login()
        })
    }

    //login api fn
    login = () => {
        const { loaderStateTrue, loaderStateFalse, logOutApp, t } = this.props;
        const { email, password } = this.state;
        loaderStateTrue();
        let data = {}
        data["email"] = email.trim()
        data["password"] = password.trim()
        LoginController.loginGetApi(data).then((response) => {
            loaderStateFalse();
            if (response) {
                if (response.success) {
                    //new password set
                    if (response.data.challengeName == "NEW_PASSWORD_REQUIRED") {
                        this.setState({
                            modalShow: true,
                            updatedPasswordSession: response.data.session,
                            challangeName: response.data.challengeName,
                            userName: response.data.username
                        })
                    }
                } else {
                    if (response.message == "User does not exist.") {
                        Utility.toastNotifications(t('wrongEmailPassword'), "Error", "error")
                    } else {
                        Utility.toastNotifications(this.props.t('somethingWwrong'), "Error", "error")
                    }

                }
            }
        }).catch((error) => {
            loaderStateFalse();

        });


    }

    //close change password modal fn
    handleClose = () => {
        loaderStateFalse();
        this.setState({
            modalShow: false,
            updated_password: "",
            updated_confirm_password: ""
        })
    }

    //update password and confirm password input fields handle change method
    handleChange = (event) => {
        if (event.target.name == "updated_password") {
            this.setState({
                updated_passwordError: ""
            })
        }
        if (event.target.name == "updated_confirm_password") {
            this.setState({
                updated_comfirm_passwordError: ""
            })
        }
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    //update password api fn
    updatePassword = () => {
        const { updated_password, updated_confirm_password, userName, updatedPasswordSession, challangeName } = this.state;
        let valid = this.updatePasswordCheck();
        if (valid) {
            loaderStateTrue();
            let header = {};
            header["session"] = updatedPasswordSession;
            let data = {
                "email": userName,
                "password": updated_password,
                "challengeName": challangeName
            }
            LoginController.forcePasswordChange(data, header).then((response) => {
                if (response) {
                    if (response.success) {
                        Utility.toastNotifications(response.message, "Success", "success")
                        Utility.toastNotifications(response.message, "Success", "success")
                        const finalIdToken = response.data.tokenType + ' ' + response.data.idToken;
                        const accessToken = response.data.accessToken
                        const refreshToken = response.data.refreshToken
                        const userGroup = response.data.hasOwnProperty('user_group') ? response.data.user_group : [];
                        const organisationGroup = response.data.hasOwnProperty('organizations') ? response.data.organizations : [];
                        const expiresIn = LoginUtility.getExpiryDetails(response.data.expiresIn)
                        this.props.setToken(finalIdToken, accessToken, expiresIn, refreshToken, userGroup, organisationGroup, '').then(() => {
                            this.props.logOutApp().then(
                                () => history.push("/")
                            );
                        })
                        loaderStateFalse();
                    } else {
                        loaderStateFalse();
                    }
                }
            }).catch((error) => {
                this.props.logOutApp().then(
                    () => history.push("/")
                );
                loaderStateFalse();
            });
        }
    }

    //update password api validation fn
    updatePasswordCheck = () => {
        let valid = true;
        const { updated_password, updated_confirm_password } = this.state;
        if (updated_password.trim() == updated_confirm_password.trim() && updated_password.trim() != "" && updated_confirm_password.trim() != "") {
            this.setState({
                updated_passwordError: '',
                updated_comfirm_passwordError: ''
            })
        } else {
            valid = false;
            Utility.toastNotifications("Password and Confirm password does not match", "Error", "error");
        }
        return valid;
    }


    render() {
        const { t } = this.props;
        return (
            <div className="updatePassContainer">
                <Modal
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    className="forcePasswordChange"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{t('ChangePasswordButton')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="passwordRow">
                            <input type={this.state.passtype} onChange={this.handleChange} name="updated_password" value={this.state.updated_password} placeholder={t('updatepassword')} className="input__fields_property" />
                            <div className="col-md-12 errorClass error_div">{this.state.updated_passwordError}</div>
                        </div>
                        <div className="passwordRow">
                            <input type={this.state.confirmPasstype} onChange={this.handleChange} name="updated_confirm_password" value={this.state.updated_confirm_password} placeholder={t('updateconfirmpass')} className="input__fields_property" />
                            <div className="col-md-12 errorClass error_div">{this.state.updated_comfirm_passwordError}</div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.updatePassword} className="update_btn">{t('submit')}</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}




const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.mainReducerData.userCredentials,
        token: globalState.mainReducerData.token,
        access_token: globalState.mainReducerData.access_token
    };
}


export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse, setToken, setUserCredentials, logOutApp })
    (withTranslation()(UpdatePassword));